import CityItemInList from './CityItemInList'

const CityList = ({cityList, inputValue, setState, language}) => {
    return (
        <div className='flex flex-col max-h-24 overflow-auto' style={{border: "1px solid rgba(163, 163, 163, 0.33)"}}>
            {
                cityList.map((city, index) => 
                    <CityItemInList language={language} city={city} inputValue={inputValue} setState={setState} key={index}/>
                )
            }
        </div>
    )
}

export default CityList